<script setup>
const props = defineProps({
  // The currently selected value in the group (bind with v-model)
  modelValue: { type: [String, Number, Boolean], default: null },
  // This radio's own value
  value: { type: [String, Number, Boolean], required: true },
  id: { type: String, required: true },
  label: { type: String, default: "" },
  name: { type: String, default: undefined },
  disabled: { type: Boolean, default: false },
});

defineEmits(["update:modelValue", "change"]);
</script>

<template>
  <label class="ca-radio" :for="id">
    <input
      type="radio"
      :id="id"
      :name="name"
      :value="value"
      :checked="modelValue === value"
      :disabled="disabled"
      @change="
        $emit('update:modelValue', value);
        $emit('change', value);
      "
    />
    <slot>{{ label }}</slot>
  </label>
</template>
